<template>
    <renderMain />
</template>

<script lang="tsx" setup>
//* 组件库
import type { UiTypes } from "various-ui";
//* 样式
import css from "./style/index.module.less";

//* 组件属性注册
const slots = defineSlots();
const define = defineProps({ align: { type: String as PropType<UiTypes.align> } });

//* 渲染函数（主体）
const renderMain = defineComponent({
    render() {
        //* 类名
        const className = define.align ? `${css.container} ${css[define.align]}` : css.container;
        return (
            <div class={className}>
                <div class={css.aside}>{slots?.aside()}</div>
                <div class={css.main}>{slots?.default()}</div>
            </div>
        );
    },
});
</script>
